<template>
    <div class="_caseTask" :class="[
        { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
      ]">
      <div class="_taskHeading">
        <div data-v-7b6075a4="" class="md-toolbar md-transparent md-theme-default md-elevation-0">
          <div class="md-toolbar-row">
            <div :class="this.recordData && this.recordData.subject && this.recordData.subject.length > 60 ? 'applyEllipsis' : ''">{{ this.recordData && this.recordData.subject ? this.recordData.subject : "" }}</div>
          </div>
          <div id="caseTaskToolbar" class="md-toolbar-row"></div>
        </div>
        
      </div>
      
      <div class="md-card md-layout-item md-small-size-100 _commentFeedSection">
      <collapse
        class="collapse-head"
        :collapse="['Task Feed']"
        icon="keyboard_arrow_down"
        color-collapse="success _collapseFeed _collapseCaseFeed"
        :defaultActive="defaultActiveCollapseIndex"
        id="taskFeed"
      >
        <div class="_taskLayoutCard" slot="md-collapse-pane-1">
          <!-- <h3><span class="heading">Task Feed</span></h3> -->

          <div class="_commentBox" :class="{ active: showEditorFlag }">
            <div v-show="showEditorFlag">
              <div class="_commentBox__form">
                <md-field class="_tinyMceField">
                  <TinyMceEditor
                    v-model="comment.body"
                    theId="comment"
                    :mentionArr="userListItems"
                    :attachments="attachmentData"
                    @itemSelected="commentItemSelected"
                    @success="onUploadSuccess"
                  />
                  <div class="dynamicList-loading-spinner" v-show="promisePending">
                    <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
                  </div>
                </md-field>
                <div>
                  <md-card-actions md-alignment="left" v-if="!attachmentData || !attachmentData.length">
                    <md-button class="md-simple md-just-icon _attachFileBtn">
                      <i class="material-icons" v-on:click="onUpload()">attachment</i>
                    </md-button>
                    <span v-if="attachmentData == null">Browse or attach file here</span>
                  </md-card-actions>
                  <md-card-content v-if="attachmentData && attachmentData.length" class="attachment-area">
                    <div class="md-layout">
                      <md-card-actions md-alignment="left">
                        <md-button class="md-simple md-just-icon _attachFileBtn">
                        <i class="material-icons" v-on:click="onUpload()">attachment</i>
                      </md-button>
                      </md-card-actions>
                      <div class="md-layout-item">
                        <div class="md-layout md-gutter">
                          <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-for="(attachment, chunkIndex) in attachmentData" v-bind:key="chunkIndex">
                            <div v-show="attachment.file.name" class="attchment-card">
                              <div class="attchment-container">{{ attachment.file.name }} ({{ attachment.file.size | kb }} kb)
                                <button type="button" class="attachment-button" title="Remove" @click="removeFile(chunkIndex)" >x</button>
                              </div>
                              <!-- <md-checkbox 
                                class="attachment-area__checkbox" 
                                v-show="$Session && $Session.isInternalGroupMember"
                                v-model="isInternal"
                              >Internal</md-checkbox> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </md-card-content>
                  <md-card-actions md-alignment="right">
                    <md-checkbox v-show="$Session && $Session.isInternalGroupMember" v-model="comment.internal">Internal</md-checkbox>
                    <md-button class="md-sm md-success" :disabled="isCommentButtonDisabled" @click="sendComment()"><i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">send</i> Submit</md-button>
                    <md-button class="md-sm md-danger" @click="closeEditor('comment')"><i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">close</i> Cancel</md-button>
                  </md-card-actions>
                </div>
              </div>
            </div>
            <div v-show="!showEditorFlag" @click="showEditor('comment')">
              Click to write your comment.
            </div>
            <div class="md-autocomplete-loading" v-if="isBusy">
              <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
            </div>
          </div>
          <!-- Upload Dialog -->
          <md-dialog :md-active.sync="isUploadDialogOpen" class="_attachmentsDialog">
            <md-dialog-title>Attachment</md-dialog-title>
            <md-dialog-content>
              <CommentAttachmentsForm
                  :docTypes="docTypes"
                  :model="attachmentData"
                  @success="onUploadSuccess"
              />
            </md-dialog-content>
          </md-dialog>

          <md-snackbar md-position="center" :md-active.sync="isSnackbarOpen" md-persistent>
            <span>{{ snackbarMsg }}</span>
          </md-snackbar>
            
            <TaskFeed :items="feedActive" :taskId="iframeModelId" :userListItems="userListItems" :task="recordData" />
            
            <div v-if="feedHasMore()" class="md-layout-item md-size-100 _taskLayoutCard">
              <md-button 
                  class="md-sm md-primary" 
                  @click="loadNextFeedData" 
                  title="Load More" v-if="feedHasMore()"
                  style="margin: 0 0 7px 0;"
              >Load More</md-button>
          </div>
        </div>
      </collapse>
      </div>
        <div class="md-card md-layout-item md-small-size-100">
        <CustomTaskForm
            :atShowAuditLog="onShowAuditLog"
            :update="updateForm"
            :form="form"
            :$v="$v"
            :formConfig="formConfig"
            :recordData="recordData"
            :groupIndex="groupIndex"
            :orderIndex="orderIndex"
            :taskCrud="true"
            :headerColor="headerColor"
            :isIframeMode="isIframeMode"
            :iframeModelId="iframeModelId"
        ></CustomTaskForm>
        </div>

        <!-- Audit Log Dialog on Case Task -->
        <md-dialog :md-active.sync="auditLogDialog" class="auditLogModal">
            <md-dialog-title>Audit Log</md-dialog-title>
            <md-dialog-content>
                <AuditLogDialog :list.sync="auditLogList" :filter.sync="auditLogFilter"></AuditLogDialog>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-theme-default" @click="auditLogDialog = false">Close</md-button>
            </md-dialog-actions>
        </md-dialog>
      

    </div>
</template>

<script>
    import TaskMixin from "@/pages/Tasks/Mixins/TaskMixin";
    import AuditLogDialog from "@/components/DynamicForm/AuditLogDialog";
    import TaskFeed from "@/components/TaskFeed";
    import { Tabs } from "@/components";
    import TinyMceEditor from "@/components/Editor/TinyMceEditor";
    import { Collapse } from "@/components";
    import CommentAttachmentsForm from '@/components/DynamicForm/Attachments/CommentAttachmentsForm';   
    import Attachments from '@/components/DynamicForm/Attachments/Attachments';
    const AttachmentsMixin = {
        methods: {
            getDocTypes: Attachments.methods.getDocTypes,
        }
    }; 
    export default {
        name: "CaseTask",
        mixins: [TaskMixin, AttachmentsMixin],
        props: {
            isIframeMode: {
                type: Boolean,
                default: false,
                required: false,
            },
            iframeModelId: {
                type: String,
                default: '',
                required: false,
            },
        },
        components: {
            AuditLogDialog,
            TaskFeed,
            Tabs,
            TinyMceEditor,
            Collapse,
            CommentAttachmentsForm,
        },
        data() {
          return {
            activeModel: {},
            isUploadDialogOpen: false,
            docTypes: [],
            promisePending: false,
            defaultActiveCollapseIndex: 1
          };
        },
        async mounted() {
          const urlHash = this.$route.hash;
          if (urlHash && urlHash.length) {
            this.defaultActiveCollapseIndex = 1;
          }
          this.docTypes = await this.getDocTypes();
        },
        methods: {
            /**
             * Show attachment upload form
             * @returns {Void}
             */
            onUpload() {
                this.isUploadDialogOpen = true;
            },
            /**
            * Attachment was successfully added or updated
            * Close dialog
            * @returns {Void}
            */
            onUploadSuccess(attachmentData) {
                this.isUploadDialogOpen = false;
                this.attachmentData = attachmentData;
                console.log("attachmentData ", attachmentData);
            },
            removeFile(fileIndex){
                this.attachmentData.splice(fileIndex, 1)
            },    
        }
    };
</script>
<style lang="scss">
._collapseFeed .md-collapse-content {
  position: relative;
  padding-top: 30px;

  ._filter {
    top: 0;
  }
}

._collapseCaseFeed .md-collapse-content {
  padding: 0;
}

#taskFeed {
  margin-top: 45px;
}

#details.md-tab {
  padding: 0 !important;
}

.applyEllipsis{
  width: 75%;
  text-overflow: ellipsis !important;
  overflow: hidden;
  white-space: nowrap !important;
}
</style>
